const getTooltips = tokens => ({
  mr1: {
    distributionTooltip: tokens.mogulReit1DistributionTooltip,
  },
  mr2: {
    distributionTooltip: tokens.mogulReit2DistributionTooltip,
  },
});

export default getTooltips;
